module.exports = __webpack_public_path__ + "static/media/6.4aea18ab.jpg";